/**
 * WebSocket Sync Protocol Types and Utilities
 *
 * Extracted from websocket.js for modularity.
 * Contains message types, connection states, and binary encoding helpers.
 */

/**
 * Message types for the sync protocol
 */
export const MessageType = {
  // Client -> Server (must match backend Rust enum variants)
  SYNC_STEP_1: "sync-step1", // Client sends state vector
  UPDATE: "update", // Client sends CRDT update (legacy - full state)
  DELTA_UPDATE: "delta-update", // Client sends delta only (new)
  FULL_STATE_UPDATE: "full-state-update", // Client sends full state for compaction (new)
  HEARTBEAT: "heartbeat", // Keep-alive ping

  // Server -> Client
  SYNC_STEP_2: "sync-step2", // Server sends missing updates
  REMOTE_UPDATE: "remote-update", // Update from another client
  PRESENCE: "presence", // Who's viewing the document
  UPDATE_AVAILABLE: "update-available", // New frontend version available
  UNSHARED: "unshared", // Document was unshared
  REMOVED: "removed", // User was removed from share
  COMPACTION_ACK: "compaction-ack", // Server acknowledges compaction
  DELTA_ACK: "delta-ack", // Server acknowledges a durably stored delta
  HEARTBEAT_ACK: "heartbeat-ack", // Server acknowledges heartbeat (for connection health)
  ERROR: "error", // Error message
  DEK_ROTATED: "dek-rotated", // Share DEK was rotated - reconnect with new key
  SESSION_INVALIDATED: "session-invalidated", // Server is closing this socket; { reason }
  RESYNC: "resync", // This socket missed broadcasts: sync again on it; { reason }
};

/**
 * Connection states
 */
export const ConnectionState = {
  DISCONNECTED: "disconnected",
  CONNECTING: "connecting",
  CONNECTED: "connected",
  SYNCING: "syncing",
  SYNCED: "synced",
  RECONNECTING: "reconnecting",
  ERROR: "error",
};

/**
 * Encode bytes to base64
 * @param {Uint8Array} bytes
 * @returns {string}
 */
export function encodeBytes(bytes) {
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

/**
 * Decode base64 to bytes
 * @param {string} base64
 * @returns {Uint8Array}
 */
export function decodeBytes(base64) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}
